'use client'

import { Button, Text } from '@vinted/web-ui'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'

import { useTracking } from '@marketplace-web/observability/event-tracker-data'
import { clickEvent } from '@marketplace-web/marketing-campaigns/marketing-landing-page-data'

const ClosingSection = () => {
  const translate = useTranslate('item_verification')
  const { track } = useTracking()

  const trackClickEvent = (target: Parameters<typeof clickEvent>[0]['target'], url: string) => {
    track(
      clickEvent({
        screen: 'item_verification',
        target,
        targetDetails: `closing_section__${url}`,
      }),
    )
  }

  return (
    <section className="item-verification__closing" data-testid="closing">
      <div className="item-verification__closing-content">
        <h2 className="item-verification__closing-title">{translate('closing.title')}</h2>
        <p className="item-verification__closing-description">{translate('closing.description')}</p>
        <div className="item-verification__closing-actions">
          <Button
            url={translate('url.cta')}
            styling={Button.Styling.Filled}
            inverse
            onClick={() => trackClickEvent('cta_redirect', translate('url.cta'))}
            testId="closing-main_cta"
          >
            {translate('actions.primary')}
          </Button>
          <Text as="span">
            <a
              href={translate('url.help')}
              className="item-verification__closing-link"
              onClick={() => trackClickEvent('hyperlink', translate('url.help'))}
              data-testid="closing-secondary_cta"
            >
              {translate('actions.secondary')}
            </a>
          </Text>
        </div>
      </div>
    </section>
  )
}

export default ClosingSection
